export const plans = {
    annual: import.meta.env.VITE_APP_MENSAL_PRICE,
    monthly: import.meta.env.VITE_APP_SEMIANNUAL_PRICE,
    semiannual: import.meta.env.VITE_APP_ANNUAL_PRICE
}

export const plansPrices = {
    monthly: "R$ 99,00",
    semiannual: "R$ 474,00",
    annual: "R$ 828,00"
}

export const rawPlanPrices = {
    monthly: 99.00,
    semiannual: 474.00,
    annual: 828.00
} as const

export const plansName = {
    monthly: "Mensal",
    semiannual: "Semianual",
    annual: "Anual"
}

export const plansMonths = {
    monthly: "mês",
    semiannual: "6 meses",
    annual: "12 meses"
}